var map = {
	"./a11y-labels.json": 557,
	"./alter-ego.json": 558,
	"./art-prize/2019.json": 559,
	"./art-prize/2020.json": 560,
	"./art-prize/global.json": 561,
	"./auth.json": 562,
	"./beginners-series.json": 563,
	"./careers-position.json": 564,
	"./careers.json": 565,
	"./faq.json": 566,
	"./footer.json": 567,
	"./global.json": 568,
	"./handbook.json": 569,
	"./home.json": 570,
	"./insight.json": 571,
	"./ipad-3d.json": 572,
	"./ipad-a11y.json": 573,
	"./ipad-brushes.json": 574,
	"./ipad-color.json": 575,
	"./ipad-superpowers.json": 576,
	"./ipad-video.json": 577,
	"./ipad-whats-new.json": 578,
	"./ipad.json": 579,
	"./meta.json": 580,
	"./navigation.json": 581,
	"./pocket-whats-new.json": 582,
	"./pocket.json": 583,
	"./press.json": 584,
	"./prize.json": 585,
	"./sitemap.json": 586,
	"./support.json": 587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;